import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap"
import PropTypes from "prop-types"
import axios from "axios";
import { nFormat } from "../../../Vendor/common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExchange } from "@fortawesome/free-solid-svg-icons";
import ModalAccountTransfer from "../ModalAccountTransfer";

const ModalArea = (props) => {
    const [areaList,setAreaList] = useState([])
    const [busyAreaListResources, setBusyAreaListResources] = useState([])
    const [busyAreaList, setBusyAreaList] = useState([])
    const [itemAccountsResource,setItemAccountsResource] = useState([])
    const [intervalControl,setIntervalControl] = useState(false)
    const [intervalVariable,setIntervalVariable] = useState(null)
    const [openTransfer,setOpenTransfer] = useState(false)

    // let intervalVariable = null
    
    const getItemsByList = async (arr) => {
        try {
            // eslint-disable-next-line no-undef
            const resource = await axios.post(process.env.REACT_APP_PATH_API + 'get/items/by/accounts',
                {
                    token: localStorage.getItem('OSHEN-LOC-STR-TK'),
                    accounts: arr
                }),
                data = await resource.data;
                setItemAccountsResource(data)
        } catch (err) {
            console.log('Error en consulta de articulos de cuenta', err)
        }
    }
    const getBusyTable = async() => {
        //Consultar lista de mesas con cuenta
        try {
            // eslint-disable-next-line no-undef
            const resource = await axios.post(process.env.REACT_APP_PATH_API + 'get/tables/with/account',
                {
                    token: localStorage.getItem('OSHEN-LOC-STR-TK'),
                    // defineCurrency: defineCurrency
                }),
                data = await resource.data;
                if(data.sessionOut){
                    // eslint-disable-next-line no-undef
                    location.href=process.env.REACT_APP_PATH_APP;
                    return;
                }
                setBusyAreaListResources(data.busy)
        } catch ( err ) {
            console.log('error en consultar mesas ocupadas', err)
        }
    }
    useEffect(()=>{
        let rows = [],
        columns = [];
        if ( props.accounts !== undefined && props.accounts !== null && props.accounts.length )
        {
            let noDefineColumn = []
            noDefineColumn.push(
                <div key={'column-no-defined'} className='col-md-2'>
                    <div className="card cursor" id={0} onClick={()=>{
                        props.setTableAccount(0)
                        props.setTableAccountDescription("")
                        props.setVisible(false)
                        props.setOpenModalAccount(true)
                        setBusyAreaList([])
                    }}>
                        <div className="card-body" style={{padding: 0}}>
                            <p className="card-content-label card-content-text-18 card-options-2" style={{textAlign: 'center'}}>
                                No definido
                            </p>                                
                        </div>
                    </div>
                </div>
            );
            rows.push(noDefineColumn)

            props.accounts.map(({description,value}, index)=>{
                columns.push(
                    <div key={'column-'+index} className='col-md-2'>
                        <div className="card cursor" id={value} onClick={()=>{
                            props.setTableAccount(value)
                            props.setTableAccountDescription(description)
                            props.setVisible(false)
                            props.setOpenModalAccount(true)
                            }}>
                            <div className="card-body" style={{padding: 0}}>
                                <p className="card-content-label card-content-text-18 card-options-2" style={{textAlign: 'center'}}>
                                    {description} 🏛️
                                </p>                                
                            </div>
                        </div>
                    </div> 
                );
                if(index>0&&((index+1)%6)===0){
                    rows.push(<div key={'row-'+index} className='row' style={{marginBottom: '1rem'}}>{columns}</div>);
                    columns = [];
                } else {
                    if(props.accounts[(index+1)]===undefined){
                        rows.push(<div key={'row-'+index} className='row' style={{marginBottom: '1rem'}}>{columns}</div>);
                        columns = [];
                    }
                }
            })
            setAreaList(rows)
        }
    }, [props.accounts])
    useEffect(async()=>{
        if ( props.visible ) 
        {
            getBusyTable()
            if ( !intervalControl ){
                const ival = setInterval(()=>{
                    getBusyTable()
                }, 40000)
                setIntervalControl(true)
                setIntervalVariable(ival)
            }
        } 
        else 
        {
            clearInterval(intervalVariable);
            setIntervalControl(false);
        }
    },[props.visible])
    useEffect(()=>{
        let rows = [],
        columns = [];
        if ( busyAreaListResources !== undefined && busyAreaListResources !== null && busyAreaListResources.length )
        {
            busyAreaListResources.map(({mesa_des, customer_name, total_amount, id, productsReady, productsPickedUp, user_name}, index)=>{
                columns.push(
                    <div key={'busy-column-'+index} className='col-md-2'>                        
                        <div className="card cursor" id={id} onClick={(input)=>{
                            const id = input.currentTarget.getAttribute('id');
                            const splitted = id.split(',')
                            if ( splitted.length > 1 )
                            {
                                //mas de 1
                                getItemsByList(splitted)
                            }
                            else
                            {
                                //1
                                {/* eslint-disable-next-line react/prop-types*/}
                                props.setOpenAccountRegistered(splitted[0])
                                props.setVisible(false)
                                setBusyAreaList([])
                            }                            
                            }}>
                            <div className="card-header text-white bg-danger">Ocupada</div>
                            <div className="card-body" style={{padding: 0}}>
                                <p className="card-content-label card-content-text-18 card-options" style={{paddingBottom: 0}}>
                                    {mesa_des} 🍽️
                                </p><br />
                                <label style={{width: '100%',textAlign: 'left',paddingLeft: 10,fontSize: 12}}><strong>Cuentas en area</strong>: {id}</label><br />
                                <label style={{width: '100%',textAlign: 'left',paddingLeft: 10,fontSize: 12}}><strong>Cantidad de cuenta</strong>: {id.split(',').length}</label><br />
                                <label style={{width: '100%',textAlign: 'left',paddingLeft: 10,fontSize: 12}}><strong>Cliente</strong>: {customer_name}</label><br />
                                <label style={{width: '100%',textAlign: 'left',paddingLeft: 10,fontSize: 12}}><strong>Mesero</strong>: {user_name}</label><br />
                                {
                                    productsReady!==undefined&&productsReady!==null&&productsReady.length?                                    
                                    <>
                                    <hr />
                                    <h6 className="blink_me" style={{width: '100%',textAlign: 'left',paddingLeft: 10,fontSize: 18}}>Disponibles para recoger</h6>
                                    {
                                        productsReady.map(({product_des,qty,unit_des,additionals}, productReadyIndex)=>{
                                            return (
                                                <div key={`product-ready-${productReadyIndex}`}>
                                                    <p style={{width: '100%',textAlign: 'left',paddingLeft: 10,fontSize: 12}}>
                                                        {`${product_des}`} <strong>{`${qty} ${unit_des.toUpperCase()}`}</strong>
                                                        <br />
                                                        <span className="text-primary">{additionals}</span>
                                                    </p>
                                                </div>
                                            )
                                        })
                                    }
                                    </>
                                    :null
                                }
                                {
                                    productsPickedUp!==undefined&&productsPickedUp!==null&&productsPickedUp.length?                                    
                                    <>
                                    <hr />
                                    <h6 className="text-info" style={{width: '100%',textAlign: 'left',paddingLeft: 10,fontSize: 18}}>Consumidos</h6>
                                    {
                                        productsPickedUp.map(({product_des,qty,unit_des,additionals}, productReadyIndex)=>{
                                            return (
                                                <div key={`product-ready-${productReadyIndex}`}>
                                                    <p style={{width: '100%',textAlign: 'left',paddingLeft: 10,fontSize: 12}}>
                                                        {`${product_des}`} <strong>{`${qty} ${unit_des.toUpperCase()}`}</strong>
                                                        <br />
                                                        <span className="text-primary">{additionals}</span>
                                                    </p>
                                                </div>
                                            )
                                        })
                                    }
                                    </>
                                    :null
                                }
                                <hr />
                                <label style={{width: '100%',textAlign: 'left',paddingLeft: 10,fontSize: 16}}>${nFormat(total_amount)}</label><br />
                            </div>
                        </div>
                    </div> 
                );
                if(index>0&&((index+1)%6)===0)
                {
                    rows.push(<div key={'row-'+index} className='row' style={{marginBottom: '1rem'}}>{columns}</div>);
                    columns = [];
                } 
                else 
                {
                    if(busyAreaListResources[(index+1)]===undefined)
                    {
                        rows.push(<div key={'row-'+index} className='row' style={{marginBottom: '1rem'}}>{columns}</div>);
                        columns = [];
                    }
                }
            })
            setBusyAreaList(rows)
        }
        else
        {
            setBusyAreaList([])
        }
    },[busyAreaListResources])
    useEffect(()=>{
        let rows = [],
        columns = [];
        if ( itemAccountsResource !== undefined && itemAccountsResource !== null && Object.keys(itemAccountsResource).length )
        {
            itemAccountsResource.accounts.map(({account, items}, index)=>{
                columns.push(
                    <div key={'busy-account-items-column-'+index} className='col-md-2'>                        
                        <div className="card cursor align-items-center" id={account} onClick={(input)=>{
                            const id = input.currentTarget.getAttribute('id');
                            {/* eslint-disable-next-line react/prop-types*/}
                            props.setOpenAccountRegistered(id)
                            props.setShowModalItemAccount(false)
                            props.setVisible(false)
                            setBusyAreaList([])
                            }}>
                            <div className="card-header text-white bg-primary" style={{width: '100%'}}>Cuenta: #{account}</div>
                            <div className="card-body" style={{padding: 0}}>                                
                                <p className="card-content-label card-content-text-18 card-options" style={{paddingBottom: 0}}>
                                    Artículos
                                </p>
                                {
                                    items.map(({product_des,qty}, idxItem)=>{
                                        return (<>
                                            <label 
                                                key={`${idxItem}`} 
                                                style={{width: '100%',textAlign: 'left',paddingLeft: 10,paddingRight: 10}}>
                                                    {product_des} - Cant. {qty}
                                            </label><br />
                                        </>)
                                    })
                                }                            
                            </div>
                        </div>
                    </div> 
                );
                if(index>0&&((index+1)%6)===0)
                {
                    rows.push(<div key={'row-'+index} className='row' style={{marginBottom: '1rem'}}>{columns}</div>);
                    columns = [];
                } 
                else 
                {
                    if(itemAccountsResource.accounts[(index+1)]===undefined)
                    {
                        rows.push(<div key={'row-'+index} className='row' style={{marginBottom: '1rem'}}>{columns}</div>);
                        columns = [];
                    }
                }
            })
            props.setItemAccounts(rows)
            props.setShowModalItemAccount(true)
        }
    },[itemAccountsResource])
    return (
        <>
        <Modal fullscreen={true} show={props.visible} onHide={()=>props.setVisible(false)}>
            <Modal.Header className="custom-modal-header" closeButton>
                <Modal.Title>Selección de Área</Modal.Title>
            </Modal.Header>
            <Modal.Body>                
                {
                    busyAreaList.length?
                        <div className="row">
                            <div className="col d-md-flex justify-content-md-end">
                                <button className="btn btn-primary" onClick={()=>setOpenTransfer(true)}>
                                    <FontAwesomeIcon icon={faExchange} /> Transferir Cuenta
                                </button>  
                            </div>
                        </div>                    
                    :null
                }                
                {busyAreaList.length?
                    <>
                    <div className="row">
                        <div className="col">
                            <h3>Áreas ocupadas <span className="text-sm text-muted" style={{fontSize: 14}}>Selecciona el área para visualizar las cuentas</span></h3>
                        </div>
                    </div>
                    {busyAreaList}
                    </>
                :null}
                <div className="row">
                    <div className="col">
                        <h3>Todas las áreas <span className="text-sm text-muted" style={{fontSize: 14}}>Selecciona el área de la cuenta</span></h3>
                    </div>
                </div>
                {areaList}
            </Modal.Body>
        </Modal>
        <ModalAccountTransfer 
            accounts={busyAreaListResources} 
            areas={props.accounts} 
            visible={openTransfer}
            setVisible={setOpenTransfer}
            getBusyTable={getBusyTable}
        />
        </>
    )
}

ModalArea.propTypes = {
    visible: PropTypes.bool,
    setVisible: PropTypes.func,
    accounts: PropTypes.array,
    setTableAccount: PropTypes.func,
    setTableAccountDescription: PropTypes.func,
    setOpenAccountRegistered: PropTypes.func,
    setItemAccounts: PropTypes.func,
    setShowModalItemAccount: PropTypes.func,
    setOpenModalAccount: PropTypes.func
}

export default ModalArea